import React from 'react';
import {SafeAreaView} from 'react-native';
import {tID} from '../../utils/TestIdHelper';
import makeStyles from './styles';
import {useThemedStyles} from '../../theme';

const UI = ({children, openPopup}) => {
  const styles = useThemedStyles(makeStyles);
  return (
    <>
      {openPopup ? (
        <SafeAreaView
          testID={tID('ChangePhoneNumber-SafeAreaView-OverlayContainer')}
          style={styles.overlayContainer}>
          {children}
        </SafeAreaView>
      ) : null}
    </>
  );
};

export default UI;
